/* eslint-disable no-console */
/* eslint-disable no-undef */

const logError = err => {
  if (import.meta.env.DEV) {
    console.error('An error occurred:', err)
  }
}

export default logError
